module.exports = __webpack_public_path__ + "static/media/spank.ee576ddc.svg";